import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { Seo } from '@components/Seo';
import Regulation from '@docs/regulamin.raw.html';

const REGULATION_TITLE = 'Regulamin';
const REGULATION_DESCRIPTION =
  'Regulamin serwisu internetowego Praca na Kołach. Warunki świadczenia usług, ogłoszenia, płatności i ochrona danych.';

export const RegulationView: React.FC<RouteComponentProps> = ({ location }) => {
  const canonicalUrl =
    typeof window !== 'undefined' && location
      ? `${window.location.origin}${location.pathname}`
      : undefined;
  const docWithSingleH1 = Regulation.replace(/<h1/gi, '<h2').replace(/<\/h1>/gi, '</h2>');
  return (
    <>
      <Seo title={REGULATION_TITLE} description={REGULATION_DESCRIPTION} url={canonicalUrl} />
      <div className="grid-container">
        <div className="grid-x align-center">
          <div className="cell">
            <h1 style={{ marginBottom: 24 }}>{REGULATION_TITLE}</h1>
            <div className="doc" dangerouslySetInnerHTML={{ __html: docWithSingleH1 }} />
          </div>
        </div>
      </div>
    </>
  );
};
